<template src="./issue-details.html"/>

<script>

import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import { EventBus } from '@/router/bus'
import i18n from '@/i18n'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      status: [
        {
          color: '#CFD8DC',
          dark: false
        },
        {
          color: '#52c0a8',
          dark: true
        },
        {
          color: '#3d92b6',
          dark: true
        },
        {
          color: '#d3454a',
          dark: true
        }
      ],
      selectedTemplate: null,
      templates: [],
      IssueStatus: {
        PENDING: 1,
        RESOLVED: 2,
        UNRESOLVED: 3,
        DENIED: 4
      },
      updateIssueTitle: null,
      pageLoader: false,
      issueId: null,
      issue: {
        status: 0
      },
      user: null,
      newComment: null,
      updateIssueStatus: 1,
      dialog: false,
      loading: false
    }
  },
  computed: {
    userStatusMessage () {
      return this.formatOperatorUserStatus(this.user, this.UserStatus)
    }
  },
  mounted () {
    this.pageLoader = true
    this.issueId = this.$route.params.issueId
    this.$http.get(Vue.$apiConfig.issueGet + '/' + this.issueId).then(
      response => {
        this.logConsole(response)
        this.issue = response.data.payload.issue
        this.user = response.data.payload.user
        this.populateResolveTemplates()
        this.pageLoader = false
      },
      error => {
        this.logConsole(error)
        this.formatErrorResponse(error, this.errorCodeSource)
        this.pageLoader = false
      }
    )
  },
  methods: {
    populateResolveTemplates () {
      this.templates = [
        'Poštovani, Vaša prijava je prihvaćena. Isplata počinje 25.9.2023. godine.',
        'Poštovani, niste podneli prijavu na način propisan Zakonom, sa identičnim podacima koje ste naveli prilikom reklamacije. Potrebno je da podnesete prijavu, najkasnije do 20.9.2023.godine, na sajtu idp.trezor.gov.rs, odabirom opcije Podnošenje prijave.',
        'Poštovani, pravo na novčanu pomoć ima žena koja je na dan stupanja na snagu Zakona upisana u matičnu knjigu rodjenih kao majka deteta, koja je državljanin RS, ima prebivalište na teritoriji RS i ima status roditelja koji vrši roditeljsko pravo prema detetu. U Vašem slučaju neki od navedenih uslova nije ispunjen.',
        'Poštovani, pravo na novčanu pomoć ima muskarac koja je na dan stupanja na snagu Zakona upisan u matičnu knjigu rodjenih kao otac deteta, koji je državljanin RS, ima prebivalište na teritoriji RS i koji sam vrši roditeljsko pravo prema detetu. U Vašem slučaju neki od navedenih uslova nije ispunjen.',
        'Poštovani, pravo na novčanu pomoć ima fizičko lice koje je na dan stupanja na snagu Zakona pravnosnažnim rešenjem organa starateljstva postavljeno za staratelja deteta, koje je državljanin RS i ima prebivalište na teritoriji RS. U Vašem slučaju neki od navedenih uslova nije ispunjen.',
        'Poštovani, ne ispunjavate uslove za dobijanje novčane pomoći jer Vaši podaci nisu uskladjeni sa podacima koje je u Registar dostavilo Ministarstvo unutrašnjih poslova.',
        'Poštovani, uvidom u evidenciju koju je dostavilo Ministarstvo za rad, zapošljavanje, boračka i socijalna pitanja na dan 1.8.2023. godine, ustanovljeno je da niste prijavljeni od strane navedenog ministarstva sa podacima koje ste naveli prilikom reklamacije. Za sva dalja pitanja potrebno je da se obratite Ministarstvu za rad, zapošljavanje, boračka i socijalna pitanja.',
        'Poštovani, Vaša reklamacija se obradjuje. Bićete obavešteni nakon izvršenih provera.',
        'Poštovani, niste podneli prijavu na način propisan Zakonom, sa identičnim podacima koje ste naveli prilikom reklamacije.'
      ]
      if (this.user && this.user.status !== this.UserStatus.PENDING) {
        this.templates.unshift(`Poštovani, Vasa novčana pomoć će biti uplaćena na račun u banci ${this.getBankName(this.user.bank)}`)
      }
    },
    resolveDialog () {
      this.dialog = true

      this.updateIssueTitle = i18n.t('issue.resolveTitle')
      this.updateIssueStatus = this.IssueStatus.RESOLVED
    },
    unresolveDialog () {
      this.dialog = true

      this.updateIssueTitle = i18n.t('issue.unresolveTitle')
      this.updateIssueStatus = this.IssueStatus.UNRESOLVED
    },
    denyDialog () {
      this.dialog = true

      this.updateIssueTitle = i18n.t('issue.denyTitle')
      this.updateIssueStatus = this.IssueStatus.DENIED
    },
    updateIssue () {
      this.loading = true
      const data = {
        id: parseInt(this.$route.params.issueId),
        comments: this.newComment,
        status: this.updateIssueStatus
      }
      this.$http.post(Vue.$apiConfig.issueUpdatePost, data).then(
        response => {
          this.logConsole(response)
          this.loading = false
          this.dialog = false
          this.newComment = ''

          const payload = response.data.payload

          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('issue.changeStatusSuccess')
          })

          this.issue.status = payload.status
          this.issue.changedComments = payload.changedComments
          this.issue.changedUserId = payload.changedUserId
          this.issue.lastChangeDate = payload.lastChangeDate
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error, this.errorCodeSource)
          this.dialog = false
          this.loading = false
        }
      )
    },
    gotoUser () {
      this.$router.push({ path: '/subsidy/user/review-anonymous-user', query: { uniqueIdentificationNumber: this.issue.uniqueIdentificationNumber, identificationNumber: this.issue.identificationNumber } })
    },
    gotoValidUser () {
      this.$router.push({ path: '/subsidy/user/review-valid-user', query: { uniqueIdentificationNumber: this.issue.uniqueIdentificationNumber } })
    },
    gotoValidUserById () {
      this.$router.push({ path: '/subsidy/user/review-valid-user', query: { identificationNumber: this.issue.identificationNumber } })
    },
    userDetailsColor () {
      if (this.user && this.user.status === this.UserStatus.PENDING) {
        return 'blue-gray'
      } else {
        return 'info'
      }
    }
  }
}
</script>
